export default function getUrl(input: RequestInfo | URL): URL {
  if (typeof input === "string") {
    return new URL(input, window.location.href);
  }
  if (input instanceof URL) {
    return input;
  }
  return new URL(input.url);
}
